import * as Sentry from '@sentry/react';
import { SENTRY_DSN, SENTRY_ENVIRONMENT } from 'constants/config';
import { IGNORE_SENTRY_ERRORS } from 'constants/errors';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { beforeSend } from './sentry-filter';

const isTestEnvironment =
  typeof window === 'undefined' ||
  process.env.NODE_ENV === 'test' ||
  typeof jest !== 'undefined';

if (!isTestEnvironment) {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: process.env.RELEASE,
    environment: SENTRY_ENVIRONMENT,
    maxBreadcrumbs: 50,
    normalizeDepth: 6,
    ignoreErrors: IGNORE_SENTRY_ERRORS,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
        beforeStartSpan: context => {
          return {
            ...context,
            name: context.name
              .replace(/\/tracking\/(.+)/g, '/tracking/:tracking_id')
              .replace(/\/orders\/(.+)/g, '/orders/:order_id')
              .replace(/\/payment\/(.+)/g, '/payment/:payment_id')
              .replace(/\/kyc\/(.+)/g, '/kyc/:kyc_id'),
          };
        },
      }),
    ],
    enabled:
      SENTRY_ENVIRONMENT !== '$ENVIRONMENT' && SENTRY_ENVIRONMENT !== 'local',
    tracesSampleRate: 0.2,
    beforeBreadcrumb(breadcrumb) {
      return breadcrumb.category === 'console' ? null : breadcrumb;
    },
    beforeSend,
  });
}
